exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edit-dialog[data-v-23962cb6] {\n  border-bottom: 1px solid #e0e0e0;\n}\n.row-disabled[data-v-23962cb6] {\n  opacity: 80%;\n}\n", ""]);

// exports
